const isProduction = (siteDomain) =>
  !!siteDomain?.startsWith("https://www.asos.com");

export default isProduction;
